export default "__VITE_ASSET__CbTneA2z__"